import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CorporationService } from 'src/app/services/corporation.service';
import { GlobalService } from 'src/app/services/global.service';
@Component({
  selector: 'app-phone-numbers',
  templateUrl: './phone-numbers.component.html'
})
export class PhoneNumbersComponent {
  phoneForm: FormGroup;
  phoneNumbers: string[] = [];
  isLoading: boolean = true;
  constructor(
    public dialogRef: MatDialogRef<PhoneNumbersComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private corporationService: CorporationService,
    private globalService: GlobalService
  ) {
    this.phoneForm = this.fb.group({
      phoneNumber: ['90', [Validators.required, Validators.pattern(/^[0-9]{12}$/)]]
    });

    if (data.corporationId) {
      this.corporatePhones();
    }
  }

  corporatePhones(): void {
    this.corporationService.getPhoneNumbers(this.data.corporationId).subscribe((result: any) => {
      this.phoneNumbers = result.data;
      this.isLoading = false;
    });
  }

  addPhoneNumber() {
    this.isLoading = true;
    if (this.phoneForm.valid) {
      this.corporationService.savePhoneNumber(this.data.corporationId, this.phoneForm.value.phoneNumber).subscribe((result: any) => {
        this.corporatePhones();
      }, this.globalService.handleError);
    }
  }

  removePhoneNumber(id: number) {
    this.corporationService.deletePhoneNumber(id).subscribe((result: any) => {
      this.corporatePhones();
    }, this.globalService.handleError);
  }

  closeDialog() {
    this.dialogRef.close(this.phoneNumbers);
  }
}
